import loadable from "@loadable/component";
import StatusIcon from "../../Icons/StatusIcon";

const DeliveryChargeListComponent = loadable(
  () => import("../../components/DeliveryCharge/DeliveryChargeList")
);

const DeliveryChargeList = () => {
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <StatusIcon />
        <span className="text-[#5E5757] font-bold text-xl">Delivery Charge</span>
      </div>
      <DeliveryChargeListComponent />
    </>
  );
};



export default DeliveryChargeList
